if(!customElements.get('ds-photo-caption')){
customElements.define('ds-photo-caption',class extends HTMLElement{
connectedCallback(){
this.root=this.closest('.shopify-section');
this.gallery=this.root?.querySelector('media-gallery');
if(!this.gallery)return;
this.mediaColors=JSON.parse(this.querySelector('[data-ds-media-colors]')?.textContent||'[]');
this.controller=new AbortController();
this.frame=0;
this.update=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.sync());};
this.querySelector('[data-ds-photo-zoom]').addEventListener('click',event=>{
const slides=this.slides();
const active=this.active(slides);
const index=Math.max(0,slides.indexOf(active));
this.gallery.zoom(index,event);
},{signal:this.controller.signal});
this.root.addEventListener('variant:update',this.update,{signal:this.controller.signal});
this.root.addEventListener('change',this.update,{signal:this.controller.signal});
this.root.addEventListener('slideshow:select',this.update,{signal:this.controller.signal});
this.observer=new MutationObserver(this.update);
this.observer.observe(this.gallery,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-hidden','aria-selected','alt','src']});
this.update();
}
slides(){return [...this.gallery.querySelectorAll('slideshow-slide')].filter(el=>!el.closest('zoom-dialog'));}
active(slides){
return slides.find(el=>el.getAttribute('aria-hidden')==='false')||slides.reduce((best,el)=>{
const rect=el.getBoundingClientRect(),area=this.gallery.getBoundingClientRect();
const width=Math.max(0,Math.min(rect.right,area.right)-Math.max(rect.left,area.left));
return !best||width>best.width?{el,width}:best;
},null)?.el;
}
sync(){
const slides=this.slides();
const image=this.active(slides)?.querySelector('img')||this.gallery.querySelector('.media-gallery__grid img');
const alt=(image?.alt||'').toLowerCase();
const colors=[...this.root.querySelectorAll('[data-ds-color-option="true"] input[type="radio"]')].map(el=>el.value);
const active=this.active(slides);
const mediaId=active?.getAttribute('slide-id')||image?.closest('[data-media-id]')?.getAttribute('data-media-id');
const mapped=[...new Set(this.mediaColors.filter(v=>v.media_id&&v.media_id===mediaId).map(v=>v.color))];
const color=colors.sort((a,b)=>b.length-a.length).find(value=>alt.includes(value.toLowerCase()))||(mapped.length===1?mapped[0]:null);
this.querySelector('[data-ds-photo-color]').textContent=color||'';
this.querySelector('[data-ds-shown]').hidden=!color;
this.querySelector('[data-ds-photo-zoom]').hidden=!image||typeof this.gallery.zoom!=='function';
}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);}
});
}
